import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Metric } from 'src/app/domain/kpi/dto/Metric';
import { MetricData } from 'src/app/domain/kpi/dto/MetricData';
import { CHART_COLORS, CHART_STYLES } from 'src/app/domain/shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';
import HC_stock from 'highcharts/modules/stock';
import { Company } from "../../../../pp/dto/Company";
HC_stock(Highcharts);
@Component({
  selector: 'app-company-one-metric-chart',
  templateUrl: './company-one-metric-chart.component.html',
  styleUrls: ['./company-one-metric-chart.component.scss'],
})
export class CompanyOneMetricChartComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() chartType = 'line';
  @Input() metric: Metric;
  @Input() metricGroupName: string;
  @Input() selectedCompany: Company;

  valueSuffix = '';
  options: any;

  ngOnInit(): void {
    this.returnOptions();
  }

  ngAfterViewInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges(): void {
    if (this.metric && this.options) {
      this.getArrays();
      this.options.plotOptions = {
        column: {
          width: 100,
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            inside: true,
            color: 'white',
            rotation: 270,
            style: {
              fontSize: '0.75rem',
              textShadow: false,
              textOutline: 'none',
            },
            formatter(): string {
              if (this.point.shapeArgs.height >= 60) {
                return Highcharts.numberFormat(this.y, 2);
              }
              this.point.visible = false; // <--hide this dataLabel
              return ''; // <--have to return "something" so, return an empty string
            },
          },
        },
      };

      Highcharts.setOptions({
        colors: ['#8BD4EA' /* skyblue*/, '#00B8AA'/* teal*/,
          '#37464A' /* charcoal*/, '#F2C816', '#5F6C6E', '#F16360',
          '#F79568', '#FFF263', '#A76A9A', '#DEBFBF', '#DEBFBF'],
        lang: {
          thousandsSep: ',',
          decimalPoint: '.',
        },
      });

      Highcharts.chart('compOneMetricChart', this.options);
    } else { }
  }


  returnOptions(): void {
    this.options = {
      chart: {
        type: 'line',
        zoomType: false,
        events: CHART_STYLES.eventForScrolling,
      },
      customRange: 30, // number of x-axis values in the scroll range
      title: {
        text: `<span>${this.metricGroupName}: ${this.metric.name}</span><br><span style="color: #4E585C; font-size: 0.9375rem; font-weight: 400">${this.selectedCompany.name}</span><br>`,
        align: 'left',
        style: {
          color: '#333333',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          fontFamily: 'Inter, sans-serif',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: CHART_STYLES.tooltipTwoLinesNoDollar,
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      xAxis: [{
        labels: {
          style: { color: '#6F777B', fontSize: '0.625rem', fontFamily: 'Inter, sans-serif' },
        },
        categories: [],
        type: 'category',
        crosshair: true,
        scrollbar: CHART_STYLES.scrollbar,
      }],
      yAxis: [{
        title: {
          enabled: false,
        },
        labels: {
          format: '{value:,.f}' + this.valueSuffix,
          style: { color: CHART_COLORS.black12, fontSize: '0.625rem', fontFamily: 'Inter, sans-serif' },
        },
        stackLabels: {
          enabled: true,
          style: { color: '#333333', fontSize: '0.8rem' },
          formatter(): string {
            let sum = 0;
            const series = this.axis.series;
            const each = Highcharts.each;
            each(series, (p) => {
              sum += p.yData[this.x];
            });
            if (sum < 0 && this.isNegative || sum > 0 && !this.isNegative) {
              return Highcharts.numberFormat(sum, 2);
            }
          },
        },
      }],
      plotOptions: {
        column: {
          width: 100,
          dataLabels: {
            enabled: true,
            inside: true,
            color: 'white',
            rotation: 270,
            format: '<b>{point.y:,.f}' + this.valueSuffix + '</b>',
            style: {
              fontSize: '0.75rem',
              textShadow: false,
              textOutline: 'none',
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: [{
        name: this.metric.name,
        type: this.chartType,
        yAxis: 0,
        color: '#00948E',
        data: [],
        connectNulls: true,
        marker: CHART_STYLES.circleMarker,
      }],
      lang: { decimalPoint: '.', thousandsSep: ',' },
    };
  }

  private getArrays(): void {
    let startingArr: number[] = [];
    const periodArr: string[] = [];
    if (this.metric?.companyMetrics[0].metricData) {
      startingArr = this.arrRounder(this.metric.companyMetrics[0].metricData, periodArr);
    } else {
      this.metric.companyMetrics[0].metricData.forEach((data) => periodArr.push(data.period.toString().slice(0, -3)));
    }
    this.options.series[0].data = startingArr;
    this.options.xAxis[0].categories = periodArr;
  }

  private arrRounder(metrics: MetricData[], periodArr: string[]): number[] {
    const roundedArr: number[] = [];
    metrics.forEach((metric) => {
      if (metric.rowValue) {
        roundedArr.push(Number(metric.rowValue));
      } else {
        roundedArr.push(null);
      }
      periodArr.push(metric.period?.toString().slice(0, -3));
    });
    return roundedArr;
  }
}
